import React from 'react';
import {
  FiBookOpen,
  FiCalendar,
  FiEdit2,
  FiX,
} from 'react-icons/fi';
import { formatKoreanDate } from '../../utils/dateUtils';

const ExamDetailModal = ({ exam, onClose, onEdit }) => {
  const schedules = Array.isArray(exam?.schedules) ? exam.schedules : [];
  const schedulesByDate = schedules.reduce((groups, schedule) => {
    if (!groups[schedule.examDate]) groups[schedule.examDate] = [];
    groups[schedule.examDate].push(schedule);
    return groups;
  }, {});

  return (
    <div className="scheduler-exam-detail-modal" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="scheduler-exam-detail" role="dialog" aria-modal="true" aria-labelledby="scheduler-exam-detail-title">
        <header>
          <span><FiCalendar aria-hidden="true" /></span>
          <div>
            <small>시험 상세</small>
            <h2 id="scheduler-exam-detail-title">{exam.examTitle}</h2>
          </div>
          <button type="button" onClick={onClose} aria-label="시험 상세 창 닫기">
            <FiX aria-hidden="true" />
          </button>
        </header>

        <div className="scheduler-exam-detail__body">
          <div className="scheduler-exam-detail__summary">
            <span>시험 시작 <strong>{formatKoreanDate(exam.examStartDate || exam.examDate)}</strong></span>
            <span>시험일 <strong>{Object.keys(schedulesByDate).length}일</strong></span>
            <span>전체 <strong>{schedules.length}과목</strong></span>
          </div>

          {Object.entries(schedulesByDate).length > 0 ? (
            <div className="scheduler-exam-detail__dates">
              {Object.entries(schedulesByDate).map(([examDate, dateSchedules], dateIndex) => (
                <section key={examDate}>
                  <h3>
                    <em>{dateIndex + 1}</em>
                    <FiCalendar aria-hidden="true" />
                    {formatKoreanDate(examDate)}
                  </h3>
                  <div>
                    {dateSchedules.map((schedule) => (
                      <p key={`${schedule.sno || schedule.rowId || ''}-${schedule.examPeriod}-${schedule.subjectName}`}>
                        <span>{schedule.examPeriod}</span>
                        <strong><FiBookOpen aria-hidden="true" /> {schedule.subjectName}</strong>
                      </p>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          ) : (
            <div className="scheduler-exam-detail__empty">등록된 과목 일정이 없습니다.</div>
          )}

          {exam.memo && (
            <section className="scheduler-exam-detail__memo">
              <h3>메모</h3>
              <p>{exam.memo}</p>
            </section>
          )}
        </div>

        <footer>
          <button type="button" onClick={onEdit}><FiEdit2 aria-hidden="true" /> 수정하기</button>
          <button type="button" onClick={onClose}>닫기</button>
        </footer>
      </section>
    </div>
  );
};

export default ExamDetailModal;
